<template>
  <span>
    <v-navigation-drawer v-model="drawer" app temporary>
      <v-toolbar flat>
        <v-app-bar-nav-icon
          default
          @click="$emit('toogleDrawer')"
        ></v-app-bar-nav-icon>
        <Logo />
      </v-toolbar>
      <v-divider></v-divider>

      <template v-slot:append>
        <v-divider></v-divider>
        <v-list dense class="mb-n2 mt-n2"> </v-list>
        <v-divider></v-divider>
        <div class="caption px-5 my-1">© 2020 {{ $t("site-name") }} LLC</div>
      </template>
    </v-navigation-drawer>
  </span>
</template>

<script>
import Logo from "./Logo";

export default {
  components: {
    Logo
  },
  props: {
    drawer: Boolean
  }
};
</script>
